import React from 'react'
import Metwentytwo from './Metwentytwo'
// import { IconAlternate } from 'components/molecules';


export const services = [
    {
      icon: 'fas fa-layer-group',
      title: 'Multitask',
      subtitle:
        'The ME220 Focused-ultrasonicator is the multi-sample, multi-application benchtop sample preparation solution for every lab. ',
    },
    {
      icon: 'fas fa-dollar-sign',
      title: 'easy-to-use ',
      subtitle:
        '	It is a compact, easy-to-use system, formatted for 1 to 8 sample batch-processing- recommend use with microTUBE-50. ',
    },
    {
      icon: 'fas fa-dna',
      title: 'Robust',
      subtitle:
        "It has Accurate, reproducible, and robust sample preparation powered by AFA-energetics",
    },
  ];

function Metwentytwopart() {
    return (
        <div>
           <Metwentytwo data = {services}/> 
        </div>
    )
}

export default Metwentytwopart
